import { AxiosResponse } from 'axios';
import api from '~/services/api';

class RatingsService {
  getAllRatings({ skip, limit = 10, ...rest }): any {
    return api.get<any[]>('/client-rating', {
      params: {
        skip,
        limit: limit,
        ...rest
      }
    });
  }

  getRowCount({ ...rest }): any {
    return api.get<any[]>('/client-rating/count', {
      params: {
        ...rest
      }
    });
  }

  getSellers(): Promise<AxiosResponse<any[] | null>> {
    return api.get<any[]>('/user', {
      params: {
        fieldsToShow: 'externalCode,name,superiorExternalCode,roleExternalCode'
      }
    });
  }

  getClients({
    skip = 0,
    limit = 20,
    userExternalCode,
    queryString
  }: {
    skip?: number;
    limit?: number;
    userExternalCode: string;
    queryString: string;
  }): Promise<AxiosResponse<any[] | null>> {
    return api.get<any[]>('/client', {
      params: {
        skip,
        limit,
        fieldsToShow: 'externalCode,name',
        userExternalCode,
        queryString
      }
    });
  }

  getCsv({ ...filters }): Promise<AxiosResponse> {
    return api.get('/client-rating/statistics', {
      params: {
        ...filters
      }
    });
  }
}

export default new RatingsService();
